import { Box, Card, Divider, FormGroup, Grid, IconButton, InputAdornment, Typography } from '@mui/material';
import { makeStyles } from "@mui/styles";

import { Collections, Contacts, FileCopy, FlightLand, FlightTakeoff } from '@mui/icons-material';
import { addDays, addHours, addSeconds, compareDesc, getUnixTime, startOfDay } from 'date-fns';
import { format, parse } from 'date-fns';
import React, { useContext } from 'react'
import { useFieldArray } from 'react-hook-form';
import BSSPreventivoContext from '../../../contexts/BSSPreventivoContext';
import BSSStyleContext from '../../../contexts/BSSStyleContext';
import currencies from '../../../currencies';

import useBSSLogger from "../../../hooks/useBSSLogger";
import { width2Breakpoint } from '../../../lib/theming';
import __t from '../../../lib/traduzioni';
import BSSDateSelector from '../../form/BSSDateSelector';
import BSSNumber from '../../form/BSSNumber';
import BSSSwitch from '../../form/BSSSwitch';
import BSSText from '../../form/BSSText';
import { _Pacchi } from '../Pacchi';
import { labelCollo, labelLocalita } from './FrammentoRiepilogo';

const {logger} = useBSSLogger()

const styles = makeStyles((theme) => {

    const desktop = theme.breakpoints.up("lg");
    const mobile = theme.breakpoints.down("md");

    const obj = {
        root: {
            display: 'flex',
        },
        content: {
            flex: '1',        
        },        
    }

    return obj;
})

const FrammentoRitiro = ({classes, methods}) => {

    const {datiPregressi, preventivoStorage, tipiSpedizione} = useContext(BSSPreventivoContext)

    const ora = new Date();
    const domani = addDays(ora, 1);
    const pickupdate = addHours(preventivoStorage?.preventivoSelezionato?.pickupdate, 0);
    const scaduto = compareDesc(pickupdate, ora) <= 0;
    const primaData = scaduto ? pickupdate : domani;

    const dateDisponibili = Array.from({length: 15}, (v, i) => addDays(primaData, i));

    logger.debug("ritiro in giornata possibile?", scaduto, "ritiro oggi entro", pickupdate, "sono le", ora, dateDisponibili)

    
    return (
        <Box width={1}>
            <Grid item className={classes.formGroupBox} >
            

                <Card>
                    <Box px={2}>
                        
                            <Typography variant="h6">
                                <Grid container style={{ display: "flex" }} justify="space-between">                                                    

                                    {__t("dataritiro")}
                                    
                                </Grid>
                            </Typography>
                    </Box>
                    
                
                    <Divider />

                    <Box p={2}>
                        <FormGroup row>
                            <Box width={1} 
                                mb={"1.2em"}>
                                
                                <BSSDateSelector
                                    name="dataritiro"
                                    dataProvider={dateDisponibili}
                                    methods={methods}
                                    ControllerProps={{
                                        rules: { 
                                            required: __t("validazione.requiredRadio"),
                                            validate: v => getUnixTime(startOfDay(parse(v, "yyyy-MM-dd", new Date()))) >= getUnixTime(startOfDay(dateDisponibili[0])) || __t("validazione.minDateField", [__t("dataritiro"), format(dateDisponibili[0], "dd/MM/yyyy")])                                            
                                        }
                                    }}
                                />
                                
                            </Box>                                                                                        
                        </FormGroup>                                                
                    </Box>                    
                </Card>

                {/* <pre>{JSON.stringify(methods.getValues(), null, 2)}</pre> */}

            </Grid>

        </Box>
    )
}

export default FrammentoRitiro;